import axios from 'axios'

/**
 * Base URL API
 */
const base = process.env.VUE_APP_API_PUBLIC

export default {
  getForm (clientKey, formId) {
    return axios.get(`${base}/${clientKey}/form/${formId}`)
  },
  getFormVersion (clientKey, formId, versionForm) {
    return axios.get(`${base}/${clientKey}/form/${formId}?v=${versionForm}`)
  },
  getFormDataId (clientKey, formId, dataId) {
    return axios.get(`${base}/${clientKey}/form/${formId}/data/${dataId}`)
  },
  signedUrl (clientKey, params, formId = null) {
    if (formId !== null) {
      return axios.post(`${base}/${clientKey}/form/${formId}/signedUrl`, params)
    } else {
      return axios.post(`${base}/${clientKey}/form/signedUrl`, params)
    }
  },
  getFileSize (clientKey, params, formId = null) {
    if (formId !== null) {
      return axios.post(`${base}/${clientKey}/form/${formId}/fileSize`, params)
    } else {
      return axios.post(`${base}/${clientKey}/form/fileSize`, params)
    }
  },
  removeTempFile (clientKey, params, formId = null) {
    if (formId !== null) {
      return axios.post(`${base}/${clientKey}/form/${formId}/removeTempFile`, params)
    } else {
      return axios.post(`${base}/${clientKey}/form/removeTempFile`, params)
    }
  },
  removeFile (clientKey, params, formId = null) {
    if (formId !== null) {
      return axios.post(`${base}/${clientKey}/form/${formId}/removeFile`, params)
    } else {
      return axios.post(`${base}/${clientKey}/form/removeFile`, params)
    }
  },
  getResource (clientKey, resourceId, input, filterGroup = 0, filterSubGroup = 0, limit = -1) {
    const headers = {
      search: JSON.stringify({ description: input })
    }

    if (filterGroup.grouper.length !== 0) {
      headers.filter_group = JSON.stringify(filterGroup)
    }
    if (filterSubGroup.subGrouper.length !== 0) {
      headers.filter_subgroup = JSON.stringify(filterSubGroup)
    }

    if (limit !== -1) {
      headers.limit = limit
    }

    return axios.get(`${base}/${clientKey}/resource/${resourceId}/data`, {
      headers
    })
  },
  getApiLimit (url, headerData, body, clientKey, securityGroup) {
    return axios.post(`${base}/${clientKey}/request`, {
      header: headerData,
      url: url,
      body: body,
      securityGroup: securityGroup
    })
  },
  getResoruceApi (url, headerData, body, clientKey, securityGroup) {
    return axios.post(`${base}/${clientKey}/request`, {
      header: headerData,
      url: url,
      body: body,
      securityGroup: securityGroup
    })
  },
  getResourceInitial (clientKey, resourceId) {
    return axios.get(`${base}/${clientKey}/resource/${resourceId}/data`, {
      headers: {
        limit: -1
      }
    })
  },
  getResourceLimit (clientKey, resourceId) {
    return axios.get(`${base}/${clientKey}/resource/${resourceId}/data`, {
      headers: {
        limit: 10
      }
    })
  }
}
